import * as React from 'react';
import { styled } from '@mui/material/styles';
import Nav from '../components/Nav';
import heroimageS from "../assets/images/small/Nadine&JP-29.webp"
import heroimageL from "../assets/images/big/Nadine&JP-29.jpg"
import image1 from "../assets/images/small/Nadine&JP-68-cropped.jpg"

import Hero from '../components/Hero';
import {
  Box,
  Grid,
  Typography,
  Container,
} from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} {...props} />
))((props) => ({
  backgroundColor: props.color ? '#F0E6DC' : '#fff',
  '&:before': {
  display: 'none',
  paddingLeft: 0,
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({

  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
  '& .MuiAccordionSummary-content p': {
    fontWeight: '700',
    textAlign: 'left',
  }, 
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  paddingLeft: '25px',
  paddingTop: '0',
  textAlign: 'left',
}));

const weddingQuestions1 = [
  {id: "question1", title: "What time does the wedding actually start?", description: "The ceremony will strictly start at 3PM, so we highly suggest to be there at least 15-30 minutes before the ceremony time."},
  {id: "question2", title: "What time should we arrive?", description: "Please be there 30 minutes before the ceremony."},
  {id: "question3", title: "What are the safety protocols during the wedding?", description: "Masks are still mandatory in the Philippines, so yes, its needs to be worn during the wedding and at all times."},
  {id: "question4", title: "Do I have to be vaccinated to attend to the wedding?", description: <><Typography>Yes. For the safety of all our guests and suppliers, we kindly ask that you need to be fully-vaccinated to be take part of the wedding.</Typography><p>Upon arriving at Oasis Manila (the reception venue), the security guard will be checking your vaccination card and body temperature. We recommend having an ART Test negative result or a PCR Test negative result at hand, in case they ask for additional verification.</p></>},
  {id: "question5", title: "Do we really need to RSVP, although we confirmed by telling the couple?", description: "Yes please! We need this in order to consolidate the guest details and finalize the headcount and the catering."},
  {id: "question6", title: "I’ve RSVP’D initially, but I can’t make it anymore. What should I do?", description: "We understand that such circumstances can occur. We do ask you to let us know as soon as possible so we can allocate your seat/s."},
  {id: "question7", title: "I’ve RSVP’d no, but my schedule has changed since then, and now I can attend. What should I do?", description: "Please let us know asap, but having said that, we may have relocated your seat to someone else. Therefore, we cannot guarantee the same number of seats that was initially given to you."},
  {id: "question8", title: "Can we bring kids to the ceremony?", description: "As much as we love kids, but due to necessity rather than choice, we regretfully cannot accommodate them at the venue due to restrictions. The only kids attending are those who are part of the entourage and those requested. We hope you understand and enjoy your night off."},
  {id: "question9", title: "Can I bring a plus one with me?", description: "Please refer to your invitation to the number of allocated seats to your party. As much as we’d love to have everyone celebrate with us, we can only accommodate a limited number of guests due to venue restrictions."},
];

const weddingQuestions2 = [
  {id: "question10", title: "What is the dress code?", styled: true, description: <><Typography>Time to have fun and dress up!</Typography><p>Ladies: Formal dresses in earthy palette and floral prints. No black or white dresses please.</p><p>Gentlemen: Your favorite suit and tie.</p><p>Strictly, no denims, jeans, sneakers or trainers, slippers or flip-flops.</p></>},
  {id: "question11", title: "What should I do between the time between the church ceremony and wedding reception?", description: <><Typography>Since the church is located in the heart of Intramurous, we highly recommend to check out other historical spots such as San Agustin Church Museum, Fort Santiago, Museo de Intramuros and many more. It’s a very IG-worthy little city , so make the most out of it!</Typography><p>You can also take a look at souvenir stores, have a quick coffee break at Casa Manila (across the street from San Agustin Church), or opt to go to your hotel room for a fresh-up before heading to the reception venue.</p></>},
  {id: "question12", title: "How do we get to the reception venue?", description: "You may use Waze or Google Maps and type “Oasis Manila”, or just hail a Grab ride there!"},
  {id: "question13", title: "Where can we park our cars at the reception venue?", description: "The reception venue can accommodate up to 100 cars, so there’s ample space for parking. You can also take Grab so you wouldn’t have to worry about getting home."},
  {id: "question14", title: "What time will the reception start?", description: "Reception doors will open at 5:30 PM. Appetizers and refreshments will be served. Use this time to mingle, register, find your seat, and take advantage of the photobooth."},
  {id: "question15", title: "Can we sit anywhere during the reception? ", description: "It took us a lot of effort and discussion to finish the seat arrangements which is planned for everyone’s convenience and network preference. So no need to worry, you’ll surely be seated with  your group of friends or better yet, make new friends!"},
  {id: "question16", title: "When is the appropriate time to leave? ", description: "It took us almost two years to plan a wedding that everyone will hopefully enjoy, so we hope you can stay ‘til the end of the program at around 9:30 PM. However, if you must, we’d love to say thank you and goodbye before you go. Maybe wait after they play the Same-Day Edit Video though :)"},
  {id: "question17", title: "Can we take photos and videos during the wedding? ", description: "We’d love to keep our ceremony unplugged as we aim to keep it solmen. Please keep your phones during the processional and ceremony. After we are announced as husband and wife, you’re free to take a shot. Plus we have amazing photographers and videographers to capture the moments. We promise to share it with you after the wedding."},
  {id: "question18", title: "Do you have an official hashtag?", description: <Typography>Yes, please use the hashtag <span style={{fontWeight: 600}}>#JPandNadinesWedding</span> when posting about our wedding as we’d love to see how the day went through your eyes too!</Typography>},
  {id: "question19", title: "Any gift preferences? ", description: "Your presence at our special day is more than enough. But if you must insist, we are happy to assist. So if you’d like to give us a gift to help us celebrate, something towards our honeyfund we would very much appreciate."},
];

const manilaThingsToDo = [
  {title: "Culture", items: ["Intramuros", "National Museum of the Philippines", "Chinatown", "Ayala Museum"]},
  {title: "Shopping", items: ["Greenbelt Mall", "Glorietta", "Mall of Asia", "Bonifacio Global City (BGC)"]},
  {title: "Fine Dine", items: ["Locavore", "Cafe Mary Grace", "The Wholesome Table", "Coffee shops at Salcedo Village, Makati"]},
  {title: "Local Dishes to Try", items: ["Adobo", "Sinigang", "Kare-Kare", "Sisig", "Street food such as isaw, fish/squid balls, balut, kwek-kwek, banana cue", "Crispy Pata", "Halo-Halo", "“Dirty” Ice cream"]},
];

const manilaQuestions1 = [
  {id: "manila1", title: "How to get around Manila?", description: <><Typography>The traffic in the Philippines is like no other, so it’s always best to give yourself ample time when you’re getting from one place to another.  If you’re flying in, it’s best to use Grab App to get around town. </Typography><p>If you want to have the true Filipino experience,  you can hop on a Jeepney or Angkas (it’s like grab for motorcyclists), however it’s best to save it on days when you don’t need to be in formal wear.</p></>},
  {id: "manila5", title: "What is there to do in Manila, the city? ", description: formatList(manilaThingsToDo)},
  {id: "manila3", title: "What are the modes of payment?", description: <><Typography>Cash is universally accepted around the country as well as the Grab App.</Typography><p>But we <span style={{fontStyle: "italic"}}>highly recommend</span> the popular method G-Cash (a virtual wallet that’s conveniently used by local stores), which you can download as an app when you purchase a Globe sim card.</p></>},
];

const manilaQuestions2 = [
  {id: "manila2", title: "What’s the weather like in Manila?", description: <><Typography>During this time of the year, the Manila weather can van vary from hot/sunny to rainy.</Typography><p>Shorts and sleeveless top to brave the Manila heat, but its always helpful to bring an umbrella or a rainjacket in case for unexpected rain showers.</p></>},
  {id: "manila4", title: "Do I need a SIM Card?", description: "If you’re planning on staying in Manila for more than 3 days, we recommend getting a SIM card (preferably Globe) since it’s cheap, handy and another accessible form of payment."},
  {id: "manila6", title: "I want to travel to the beach for an extended holiday; Where should I start?", description: <><Typography style={{fontStyle: "italic"}}>If you’re planning to extend your stay in the country, we highly recommend to check out our beautiful local beaches which is accessible by domestic flights or buses.</Typography><p>Siarago & La Union are great surfing spots and for laid back beach vibes.</p><p>Boracay is great for a family getaway for white sands and crystal clear waters.</p><p>El Nido is a picturesque backdrop of the archipelago that’s so instagram worthy. It’s perfect for those with an adventurous spirit!</p></>},
];



function formatList(thingsToDo) {
  return (
  thingsToDo.map((toDo) => {
    return (
    <div>
      <Typography style={{fontStyle: "italic"}}>{toDo.title}</Typography>
      <ul>
        {toDo.items.map(item => <li>{item}</li>)}
      </ul>
    </div>
    )
  })
  );
};

function QA(props) {
  const [expanded, setExpanded] = React.useState('question1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const defaultText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
  malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
  sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
  sit amet blandit leo lobortis eget.`;

  return (
    <>
      {props.questions.map((question) => {
        return (
          <Accordion className="accordion" key={question.id} onChange={handleChange(question.id)} color={props.color}>
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography>{question.title ? question.title : "Question here"}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {question.description ? question.description : defaultText}
            </Typography>
          </AccordionDetails>
        </Accordion>
        )
      })}
      </>
  );
}

export default function FAQ() {
  return (
    <Box className="faq">
      <Nav />
      <Hero name="FAQ" imageS={heroimageS} imageL={heroimageL} />
      <Box className="wedding-questions">
        <Container maxWidth="lg">
          <Grid
            container
            columnSpacing={{lg: 5}}
            className="wedding-questions"
            justifyContent="space-between"
            sx={{ padding: { xs: '3em 0', md: '3em 0', lg: '5em 0', xl: '7em 0' }}}
          >
            <Grid item xs={12}>
              <Typography variant="h3" align="left">The Wedding</Typography>
            </Grid>
            <Grid item xs={12} lg={6}>
            <QA questions={weddingQuestions1} color="true"/>
            </Grid>
            <Grid item xs={12} lg={6}>
            <QA questions={weddingQuestions2} color="true"/>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
          className="image2"
          src={image1}
          pt={{xs: "0", lg: "5em"}}
          sx={{width: {xs: '100%', lg: '900px'}}}
          alt="JP and Nadine hugging"
          component="img" 
        />
      <Box>
        <Container maxWidth="lg">
          <Grid
            container
            columnSpacing={{lg: 5}}
            className="manila-questions"
            justifyContent="center"
            sx={{ padding: { xs: '3em 0', md: '3em 0', lg: '5em 0', xl: '7em 0' }}}
          >
            <Grid item xs={12}>
              <Typography variant="h3" align="left">Around & About Manila</Typography>
            </Grid>
            <Grid item xs={12} lg={6}>
            <QA questions={manilaQuestions1}/>
            </Grid>
            <Grid item xs={12} lg={6}>
            <QA questions={manilaQuestions2}/>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}